export default function Donate() {
  const donationOptions = [
    { amount: "$10", text: "Provide school supplies for a child" },
    { amount: "$50", text: "Sponsor a health outreach" },
    { amount: "$100", text: "Support community empowerment programs" },
  ];

  return (
    <section className="py-20 px-6 max-w-xl mx-auto text-center">
      <h2 className="text-4xl font-bold mb-6 text-[#2D033B]">Donate</h2>
      <p className="text-[#5A3D73] mb-12">
        Your generosity helps us reach more lives and build stronger communities.
      </p>

      <div className="grid md:grid-cols-3 gap-6 mb-12">
        {donationOptions.map((item) => (
          <div
            key={item.amount}
            className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition border border-[#E5D9F2]"
          >
            <h3 className="text-2xl font-bold mb-2 text-[#6A0DAD]">
              {item.amount}
            </h3>
            <p className="text-[#5A3D73]">{item.text}</p>
          </div>
        ))}
      </div>

      <button className="bg-[#6A0DAD] text-white px-8 py-3 rounded-md text-lg font-semibold transition hover:bg-[#5F0F99]">
        Donate Now
      </button>
    </section>
  );
}
